module.exports = __webpack_public_path__ + "static/media/especialistas_testimonios10.7bf87148.jpeg";